// extracted by mini-css-extract-plugin
module.exports = {"welcome__modal":"WelcomeModal_welcome__modal__kzIF7"};